// import KeyboardBacklight from "./keyboardBacklight"
// import LedStrip from "./LedStrip"
import "./CustomizeOperation.scss";
// import img001 from '@/assets/images/trigger/001.png'
import {
  keyAxisImage01,
  keyAxisImage02,
  keyAxisImage03,
} from "@eweadn-qiankun/shared-assets";
import { useEffect, useState, useRef } from "react";
import {
  Switch,
  SettingItem,
  ScaleSlider,
  Slider,
  Iconfont,
  Tooltip,
} from "@eweadn-qiankun/shared-components";
import { SetPerformanceParType } from "@eweadn-qiankun/shared-types";
// import httpApi from "@eweadn-qiankun/shared-http";
// import CheckBox from './Checkbox'
import { type SelectOption } from "./Select";
// import { useSdkApi } from "../../stores/sdkStore";
import { useTranslation } from "react-i18next";
import {
  getCurrentDevice,
  isXingshanTriggerFuriousStep0_001Mm,
  resolveShouldShowFuriousMode,
} from "../../utils";
import {
  isHuafendaMagneticAxisEquipment,
  isDk75FamilyKeyboardType,
  resolveHfdMagneticTravelRangeMm,
} from "@eweadn-qiankun/shared-utils";
import type { DeviceConfigLike } from "../../utils";

export interface CustomizeOperationProps {
  params: SetPerformanceParType;
  setParams: (params: SetPerformanceParType) => void;
  axisList: unknown[];
  isKeyData: boolean;
  configIdx?: number;
  /** 社区预览等场景：按配置型号判定，勿读 localStorage 当前设备 */
  deviceContext?: DeviceConfigLike | null;
  /** DK63Star 办公/新手/游戏板载：锁定行程与 RT 编辑 */
  controlsLocked?: boolean;
}

const triggerOperation = (porps: CustomizeOperationProps) => {
  const {
    params,
    setParams,
    axisList,
    isKeyData: isKeyDataProp,
    configIdx,
    deviceContext,
    controlsLocked = false,
  } = porps;
  const isKeyData = Boolean(isKeyDataProp) && !controlsLocked;
  const device = deviceContext ?? getCurrentDevice();
  const keyboardType = device?.keyboardType;
  const { t } = useTranslation();
  // const globalSdkApi = useSdkApi();
  // const sdkApi = globalSdkApi?.keyboard;
  // const { sdkKeyboardBasicApi } = sdkApi || {};
  // const { thirdPartyApi } = httpApi
  // const { getAxisListV3 } = thirdPartyApi
  // const [checkboxValue, setCheckboxValue] = useState(false);
  // const [checkboxLabel, setCheckboxLabel] = useState("全选");
  // const [checkboxDirection, setCheckboxDirection] = useState<"left" | "right">(
  //   "left"
  // );
  // const [selectValue, setSelectValue] = useState<string | number>('');
  const [selectOptions, setSelectOptions] = useState<SelectOption[]>([]);
  // const [switchCheck, setSwitchCheck] = useState(false);
  // const [fastTrigger, setFastTrigger] = useState(true);
  // const [layerHeight, setLayerHeight] = useState(1.6);
  // const [fillDensity, setFillDensity] = useState(1.6);
  // const [fillDensity1, setFillDensity1] = useState(1.6);

  // const [rtFirstTouch, setRtFirstTouch] = useState<string | number>(0.01); // RT触发首次触发行程值
  // const [rtFirstTouchStep, setRtFirstTouchStep] = useState<number>(0.001); // RT触发首次触发行程步值
  // const [rtFirstTouchDecimal, setRtFirstTouchDecimal] = useState<number>(3); // RT触发首次触发行程小数精度
  const [furious, setFurious] = useState(false); // 狂暴模式
  const furiousByKeyRef = useRef<Map<string, boolean>>(new Map());
  /** 用户手动切换过狂暴的按键，才用缓存；否则每次按设备行程回显 */
  const furiousUserOverrideRef = useRef<Set<string>>(new Set());

  // const [normalPress, setNormalPress] = useState(0.01); // 普通触发按下行程
  // const [normalPressStep, setNormalPressStep] = useState<number>(0.01); // 普通触发按下行程step
  // const [normalPressDecimal, setNormalPressDecimal] = useState<number>(2); // 普通触发按下行程precision

  // const [deadZone, setDeadZone] = useState(true);
  // const [pressDeadStroke, setPressDeadStroke] = useState(0.01); // 死区按下触发
  const [pressDeadStrokeStep] = useState<number>(0.01); // 死区按下触发step
  // const [pressDeadStrokeDecimal] = useState<number>(2); // 死区按下触发precision
  // const [releaseDeadStroke, setReleaseDeadStroke] = useState(0.01); // 死区按下触发
  const [releaseDeadStrokeStep] = useState<number>(0.01); // 死区按下触发step
  // const [releaseDeadStrokeDecimal] = useState<number>(2); // 死区按下触发precision
  const [childPar, setChildPar] = useState<SetPerformanceParType>(() => params);
  const shouldShowFuriousMode = resolveShouldShowFuriousMode(device);
  const isHfdMagnetic = isHuafendaMagneticAxisEquipment(device);
  const hfdTravelRange = isHfdMagnetic
    ? resolveHfdMagneticTravelRangeMm(keyboardType)
    : { min: 0, max: 3.5 };
  const triggerTravelMin = isHfdMagnetic ? hfdTravelRange.min : 0;
  const triggerTravelMax = hfdTravelRange.max;
  const rtTravelMax = isHfdMagnetic ? Math.min(3.4, hfdTravelRange.max) : 3.4;

  //  const setSelectValueFn = (data: string | number) => {
  //   const newChildPar = JSON.parse(JSON.stringify(childPar))
  //   newChildPar.axisV2Id = data
  //   setChildPar(newChildPar)
  //   setParams(newChildPar)
  //   setSelectValue(data)
  // }
  // const setNormalPressFn = (data: number) => {
  //   const newChildPar = JSON.parse(JSON.stringify(childPar))
  //   newChildPar.normalPress = data
  //   newChildPar.normalRelease = data
  //   setChildPar(newChildPar)
  //   setParams(newChildPar)
  // }
  const setSwitchCheck = (data: boolean) => {
    console.log(selectOptions);
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.mode = data ? 1 : 0;
    setChildPar(newChildPar);
    setParams(newChildPar);
  };

  const lingOneorFiveRef = useRef<boolean>(false);
  const getPerfKey = (par?: Partial<SetPerformanceParType>) =>
    `${par?.row ?? -1}-${par?.col ?? -1}`;

  const normalizeTravelValue = (
    value: number | undefined,
    step: number,
    decimal: number,
    max: number
  ) => {
    const safe = Number.isFinite(Number(value)) ? Number(value) : step;
    const clamped = Math.max(step, Math.min(safe, max));
    const snapped = Math.round(clamped / step) * step;
    return Number(snapped.toFixed(decimal));
  };
  // 获取触发行程的精度参数（根据狂暴模式）
  const getTriggerPrecision = (furiousEnabled = furious) => {
    lingOneorFiveRef.current = false;
    // 华奋达磁轴：常态 0.02 / 狂暴 0.01
    if (isHfdMagnetic) {
      return furiousEnabled
        ? { step: 0.01, decimal: 2 }
        : { step: 0.02, decimal: 2 };
    }
    let precision = { step: 0.01, decimal: 2 };
    const configurationNow = device;
    if (configurationNow?.vendorId && configurationNow?.productId) {
      const productId = configurationNow.productId;
      const vendorId = configurationNow.vendorId;
      const solutionRovider = configurationNow.solutionRovider;
      if (solutionRovider === "xingshan") {
        if (
          keyboardType === "es87" ||
          keyboardType === "x75v3" ||
          ((productId === 7178 || productId === 7180) && vendorId === 7334) ||
          (productId === 7204 && vendorId === 7334) ||
          (productId === 65153 && vendorId === 6790) ||
          (productId === 7215 && vendorId === 7334) ||
          (productId === 7242 && vendorId === 7334) ||
          (productId === 7244 && vendorId === 7334) ||
          (productId === 7248 && vendorId === 7334) ||
          isXingshanTriggerFuriousStep0_001Mm(productId, vendorId) ||
          ((productId === 7213 || productId === 7239 || productId === 7230) &&
            vendorId === 7334)
        ) {
          precision = furiousEnabled
            ? { step: 0.001, decimal: 3 }
            : { step: 0.01, decimal: 2 };
        } else if (
          (keyboardType === "gamma75" &&
            !isXingshanTriggerFuriousStep0_001Mm(productId, vendorId)) ||
          isDk75FamilyKeyboardType(keyboardType) ||
          // 以下 PID 为 keyboardType 未就绪时的历史兜底（68 / 63 / deep80max 等，非 DK75）
          (productId === 7228 && vendorId === 7334) ||
          (productId === 7186 && vendorId === 7334) ||
          (productId === 7211 && vendorId === 7334) ||
          (productId === 7203 && vendorId === 7334) ||
          (productId === 7212 && vendorId === 7334) ||
          (productId === 24065 && vendorId === 7334) ||
          (productId === 7199 && vendorId === 7334) ||
          (productId === 7229 && vendorId === 7334)
        ) {
          precision = furiousEnabled
            ? { step: 0.005, decimal: 3 }
            : { step: 0.01, decimal: 2 };
          lingOneorFiveRef.current = true;
        }
      } else {
        precision = furiousEnabled
          ? { step: 0.001, decimal: 3 }
          : { step: 0.01, decimal: 2 };
      }
    } else {
      precision = furiousEnabled
        ? { step: 0.001, decimal: 3 }
        : { step: 0.01, decimal: 2 };
    }
    return precision;
  };

  // 实时更新视觉（拖动中）
  const updateTriggerValue = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    const minValue = getTriggerPrecision().step;
    const clampedValue = Math.max(data, minValue); // 确保不小于步进精度
    if (childPar?.mode === 0) {
      // 未开启RT,更新normalPress和normalRelease
      newChildPar.normalPress = clampedValue;
      newChildPar.normalRelease = clampedValue;
    } else {
      // 开启RT,更新rtFirstTouch
      newChildPar.rtFirstTouch = clampedValue;
    }
    setChildPar(newChildPar);
  };
  const updateRtPress = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.rtPress = data;
    setChildPar(newChildPar);
  };
  const updateRtRelease = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.rtRelease = data;
    setChildPar(newChildPar);
  };
  const updatePressDeadStroke = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.pressDeadStroke = data;
    setChildPar(newChildPar);
  };
  const updateReleaseDeadStroke = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.releaseDeadStroke = data;
    setChildPar(newChildPar);
  };

  // 保存数据（拖动结束时）
  const setTriggerValueFn = async (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    const minValue = getTriggerPrecision().step;
    const clampedValue = Math.max(data, minValue); // 确保不小于步进精度
    if (childPar?.mode === 0) {
      // 未开启RT,更新normalPress和normalRelease
      newChildPar.normalPress = clampedValue;
      newChildPar.normalRelease = clampedValue;
    } else {
      // 开启RT,更新rtFirstTouch
      newChildPar.rtFirstTouch = clampedValue;
    }
    setChildPar(newChildPar);
    setParams(newChildPar);
  };
  const setRtPressFn = async (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.rtPress = data;
    setChildPar(newChildPar);
    setParams(newChildPar);
  };
  const setRtReleaseFn = async (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.rtRelease = data;
    setChildPar(newChildPar);
    setParams(newChildPar);
  };
  const setFuriousFn = (data: boolean) => {
    setFurious(data);
    if (!childPar) return;

    const perfKey = getPerfKey(childPar);
    furiousUserOverrideRef.current.add(perfKey);
    furiousByKeyRef.current.set(perfKey, data);

    const nextPar = JSON.parse(JSON.stringify(childPar));
    const triggerPrecision = getTriggerPrecision(data);
    const rtPrecision = getRtPrecision(data);

    nextPar.normalPress = normalizeTravelValue(
      nextPar.normalPress,
      triggerPrecision.step,
      triggerPrecision.decimal,
      triggerTravelMax
    );
    nextPar.normalRelease = normalizeTravelValue(
      nextPar.normalRelease,
      triggerPrecision.step,
      triggerPrecision.decimal,
      triggerTravelMax
    );
    nextPar.rtFirstTouch = normalizeTravelValue(
      nextPar.rtFirstTouch,
      triggerPrecision.step,
      triggerPrecision.decimal,
      triggerTravelMax
    );
    nextPar.rtPress = normalizeTravelValue(
      nextPar.rtPress,
      rtPrecision.step,
      rtPrecision.decimal,
      rtTravelMax
    );
    nextPar.rtRelease = normalizeTravelValue(
      nextPar.rtRelease,
      rtPrecision.step,
      rtPrecision.decimal,
      rtTravelMax
    );

    setChildPar(nextPar);
    setParams(nextPar);
  };
  const setPressDeadStrokeFn = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.pressDeadStroke = data;
    setChildPar(newChildPar);
    setParams(newChildPar);
  };
  const setReleaseDeadStrokeFn = (data: number) => {
    const newChildPar = JSON.parse(JSON.stringify(childPar));
    newChildPar.releaseDeadStroke = data;
    setChildPar(newChildPar);
    setParams(newChildPar);
  };

  // 狂暴模式回显：行程含高精度分量时打开狂暴步进
  const echoFuriousTravel = (v: number | undefined | null) => {
    if (v == null || Number.isNaN(v)) return false;
    // 华奋达磁轴：0.02 步进可整除 → 非狂暴；含 0.01 奇分量 → 狂暴
    if (isHfdMagnetic) {
      const cents = Math.round(Number(v) * 100);
      return cents % 2 !== 0;
    }
    const r2 = Math.round(v * 100) / 100;
    return Math.abs(v - r2) > 1e-6;
  };
  const echoFuriousMode = (par: SetPerformanceParType) => {
    const xs = [
      par.normalPress,
      par.normalRelease,
      par.rtFirstTouch,
      par.rtPress,
      par.rtRelease,
    ];
    return xs.some(echoFuriousTravel);
  };

  useEffect(() => {
    furiousByKeyRef.current.clear();
    furiousUserOverrideRef.current.clear();
  }, [configIdx]);

  useEffect(() => {
    setChildPar(params);
    if (!isKeyData) {
      setFurious(false);
      return;
    }
    const perfKey = getPerfKey(params);
    const inferred = echoFuriousMode(params);
    if (furiousUserOverrideRef.current.has(perfKey)) {
      const cached = furiousByKeyRef.current.get(perfKey);
      if (typeof cached === "boolean") {
        setFurious(cached);
        return;
      }
    }
    furiousByKeyRef.current.set(perfKey, inferred);
    setFurious(inferred);
  }, [params, isKeyData]);
  useEffect(() => {
    setSelectOptions(axisList);
  }, [axisList]);

  // 计算滑块位置
  const getSliderPosition = () => {
    if (!isKeyData) return 0; // 未选择按键，默认位置
    // 根据mode选择对应的值
    const value =
      childPar?.mode === 0
        ? (childPar?.normalPress ?? 0)
        : (childPar?.rtFirstTouch ?? 0);
    // 小值在顶部(负值)，大值在底部(0)
    return (value / triggerTravelMax) * 30; // 根据触发行程计算位置
  };

  // 获取触发设置的当前值
  const getTriggerValue = () => {
    return childPar?.mode === 0
      ? childPar?.normalPress
      : childPar?.rtFirstTouch;
  };

  // 获取RT精度参数（根据狂暴模式）
  const getRtPrecision = (furiousEnabled = furious) => {
    lingOneorFiveRef.current = false;
    // 华奋达磁轴：常态 0.02 / 狂暴 0.01
    if (isHfdMagnetic) {
      return furiousEnabled
        ? { step: 0.01, decimal: 2 }
        : { step: 0.02, decimal: 2 };
    }
    let precision = { step: 0.01, decimal: 2 };
    const configurationNow = device;
    if (configurationNow?.vendorId && configurationNow?.productId) {
      const productId = configurationNow.productId;
      const vendorId = configurationNow.vendorId;
      const solutionRovider = configurationNow.solutionRovider;
      if (solutionRovider === "xingshan") {
        if (
          keyboardType === "es87" ||
          keyboardType === "x75v3" ||
          ((productId === 7178 || productId === 7180) && vendorId === 7334) ||
          (productId === 7204 && vendorId === 7334) ||
          (productId === 65153 && vendorId === 6790) ||
          (productId === 7215 && vendorId === 7334) ||
          (productId === 7242 && vendorId === 7334) ||
          (productId === 7244 && vendorId === 7334) ||
          (productId === 7248 && vendorId === 7334) ||
          isXingshanTriggerFuriousStep0_001Mm(productId, vendorId) ||
          ((productId === 7213 || productId === 7239 || productId === 7230) &&
            vendorId === 7334)
        ) {
          precision = furiousEnabled
            ? { step: 0.001, decimal: 3 }
            : { step: 0.01, decimal: 2 };
        } else if (
          (keyboardType === "gamma75" &&
            !isXingshanTriggerFuriousStep0_001Mm(productId, vendorId)) ||
          isDk75FamilyKeyboardType(keyboardType) ||
          // 以下 PID 为 keyboardType 未就绪时的历史兜底（68 / 63 / deep80max 等，非 DK75）
          (productId === 7228 && vendorId === 7334) ||
          (productId === 7186 && vendorId === 7334) ||
          (productId === 7211 && vendorId === 7334) ||
          (productId === 7203 && vendorId === 7334) ||
          (productId === 7212 && vendorId === 7334) ||
          (productId === 24065 && vendorId === 7334) ||
          (productId === 7199 && vendorId === 7334) ||
          (productId === 7229 && vendorId === 7334)
        ) {
          precision = furiousEnabled
            ? { step: 0.005, decimal: 3 }
            : { step: 0.01, decimal: 2 };
          lingOneorFiveRef.current = true;
        }
      } else {
        precision = furiousEnabled
          ? { step: 0.001, decimal: 3 }
          : { step: 0.01, decimal: 2 };
      }
    } else {
      precision = furiousEnabled
        ? { step: 0.001, decimal: 3 }
        : { step: 0.01, decimal: 2 };
    }
    return precision;
  };

  // 确保值不小于最小值
  const ensureMinValue = (value: number | undefined, minValue: number) => {
    if (value === undefined || value === null || value < minValue) {
      return minValue;
    }
    return value;
  };

  return (
    <div className="triggerOperation">
      <div className="triggerOperation-item">
        <div className="routineGifMusic">
          <div className="title">
            <span className={!isKeyData ? "label disabled" : "label"}>
              {t("keyboard.trigger.triggerStroke")}
            </span>
            {/* <Checkbox
              label={checkboxLabel}
              labelPosition={checkboxDirection}
              checked={checkboxValue}
              onChange={setCheckboxValue}
            /> */}
          </div>
          <div className="routineGifMusic-main">
            <div className="keyAxisTips">
              {t("keyboard.trigger.keyAxisTips")}
            </div>
            <div className="keyAxisSelectSetting">
              <div className="keyAxisSelect">
                <div className="keyAxisImage">
                  <div className="keyAxisImage-box">
                    <img
                      src={keyAxisImage01}
                      alt="轴体底座"
                      className="keyAxisImage-01"
                      draggable="false"
                    />
                    <div className="keyAxisImage-02">
                      <img
                        src={keyAxisImage02}
                        alt="轴体滑块"
                        draggable="false"
                        style={{
                          transform: `translateY(${getSliderPosition()}%)`,
                        }}
                      />
                    </div>
                    <img
                      src={keyAxisImage03}
                      alt="轴体外壳"
                      className="keyAxisImage-03"
                      draggable="false"
                    />
                  </div>
                </div>
                <div className="keyAxisNote">
                  {t("keyboard.trigger.keyAxisNote")}
                </div>
              </div>
              <div className="keyAxisSetting">
                <ScaleSlider
                  value={getTriggerValue()}
                  onChange={updateTriggerValue}
                  onChangeComplete={setTriggerValueFn}
                  min={triggerTravelMin}
                  max={triggerTravelMax}
                  step={getTriggerPrecision().step}
                  unit="mm"
                  precision={getTriggerPrecision().decimal}
                  orientation="vertical"
                  size={160}
                  scaleCount={35}
                  showValue={true}
                  showArrow={true}
                  disabled={!isKeyData}
                  trackWidth={38}
                  showScaleValues={false}
                  scaleWidth={14}
                  showThumb={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="triggerOperation-item">
        <div className="routineGifMusic">
          <div className="title">
            <span className={!isKeyData ? "label disabled" : "label"}>
              {t("keyboard.trigger.rapidTrigger")}
            </span>
            <Switch
              disabled={!isKeyData}
              checked={isKeyData ? childPar?.mode === 1 : false}
              onChange={setSwitchCheck}
            />
          </div>
          <div className="routineGifMusic-main">
            {childPar?.mode !== 0 ? (
              <div className="triggerFast">
                <div className="triggerFast-item">
                  <div className="text">{t("keyboard.trigger.press")}</div>
                  {/* <ScaleSlider
                    value={ensureMinValue(
                      childPar?.rtPress,
                      getRtPrecision().step
                    )}
                    onChange={updateRtPress}
                    onChangeComplete={setRtPressFn}
                    min={getRtPrecision().step}
                    max={rtTravelMax}
                    step={getRtPrecision().step}
                    unit="mm"
                    precision={getRtPrecision().decimal}
                    orientation="horizontal"
                    size={300}
                    scaleCount={10}
                    showValue={true}
                    showArrow={true}
                    disabled={!isKeyData}
                  /> */}
                  <Slider
                    value={ensureMinValue(
                      childPar?.rtPress,
                      getRtPrecision().step
                    )}
                    onChange={updateRtPress}
                    onChangeComplete={setRtPressFn}
                    min={getRtPrecision().step}
                    max={rtTravelMax}
                    step={getRtPrecision().step}
                    unit="mm"
                    showValue={true}
                    valueShowTopRight={true}
                    disabled={!isKeyData}
                  />
                </div>
                <div className="triggerFast-item triggerFast-item-release">
                  <div className="text">{t("keyboard.trigger.release")}</div>
                  {/* <ScaleSlider
                    value={ensureMinValue(
                      childPar?.rtRelease,
                      getRtPrecision().step
                    )}
                    onChange={updateRtRelease}
                    onChangeComplete={setRtReleaseFn}
                    min={getRtPrecision().step}
                    max={rtTravelMax}
                    step={getRtPrecision().step}
                    unit="mm"
                    precision={getRtPrecision().decimal}
                    orientation="horizontal"
                    size={300}
                    scaleCount={10}
                    showValue={true}
                    showArrow={true}
                    disabled={!isKeyData}
                  /> */}
                  <Slider
                    value={ensureMinValue(
                      childPar?.rtRelease,
                      getRtPrecision().step
                    )}
                    onChange={updateRtRelease}
                    onChangeComplete={setRtReleaseFn}
                    min={getRtPrecision().step}
                    max={rtTravelMax}
                    step={getRtPrecision().step}
                    unit="mm"
                    showValue={true}
                    valueShowTopRight={true}
                    disabled={!isKeyData}
                  />
                </div>
              </div>
            ) : (
              <div className="rt-description">
                {t("keyboard.trigger.rtDescription")}
              </div>
            )}

            {shouldShowFuriousMode && (
              <SettingItem
                compact
                className="trigger-furious-item"
                title={t("keyboard.trigger.furiousMode")}
                description={
                  isHfdMagnetic
                    ? t("keyboard.trigger.furiousModeDescHfd")
                    : lingOneorFiveRef.current
                      ? t("keyboard.trigger.furiousModeDescDk68Star")
                      : t("keyboard.trigger.furiousModeDesc")
                }
                checked={furious}
                onChange={setFuriousFn}
                disabled={!isKeyData}
              />
            )}
          </div>
        </div>
      </div>
      <div className="triggerOperation-item">
        <div className="routineGifMusic">
          <div className="title">
            <div className="deadZone-title">
              <span className={!isKeyData ? "label disabled" : "label"}>
                {t("keyboard.trigger.deadZone")}
              </span>
              <Tooltip
                text={t("keyboard.trigger.deadZoneTooltip")}
                placement="top"
                usePortal
              >
                <Iconfont icon="information" className="deadZone-info-icon" />
              </Tooltip>
            </div>
          </div>
          <div className="routineGifMusic-main">
            <div className="keyAxisTips">
              {t("keyboard.trigger.deadZoneTips")}
            </div>
            <div className="triggerFast triggerFastWrap">
              <div className="triggerFast-item">
                <div className="text">{t("keyboard.trigger.press")}</div>
                {/* <ScaleSlider
                  value={childPar?.pressDeadStroke ?? 0.2}
                  onChange={updatePressDeadStroke}
                  onChangeComplete={setPressDeadStrokeFn}
                  min={0}
                  max={1}
                  step={pressDeadStrokeStep}
                  unit="mm"
                  precision={pressDeadStrokeDecimal}
                  orientation="horizontal"
                  size={300}
                  scaleCount={10}
                  showValue={true}
                  showArrow={true}
                  disabled={!isKeyData}
                /> */}
                <Slider
                  value={childPar?.pressDeadStroke ?? (isHfdMagnetic ? 0 : 0.2)}
                  onChange={updatePressDeadStroke}
                  onChangeComplete={setPressDeadStrokeFn}
                  min={0}
                  max={1}
                  step={pressDeadStrokeStep}
                  unit="mm"
                  showValue={true}
                  disabled={!isKeyData}
                />
              </div>
              <div className="triggerFast-item triggerFast-item-release">
                <div className="text">{t("keyboard.trigger.release")}</div>
                {/* <ScaleSlider
                  value={childPar?.releaseDeadStroke ?? 0.2}
                  onChange={updateReleaseDeadStroke}
                  onChangeComplete={setReleaseDeadStrokeFn}
                  min={0}
                  max={1}
                  step={releaseDeadStrokeStep}
                  unit="mm"
                  precision={releaseDeadStrokeDecimal}
                  orientation="horizontal"
                  size={300}
                  scaleCount={10}
                  showValue={true}
                  showArrow={true}
                  disabled={!isKeyData}
                /> */}
                <Slider
                  value={
                    childPar?.releaseDeadStroke ?? (isHfdMagnetic ? 0 : 0.2)
                  }
                  onChange={updateReleaseDeadStroke}
                  onChangeComplete={setReleaseDeadStrokeFn}
                  min={0}
                  max={1}
                  step={releaseDeadStrokeStep}
                  unit="mm"
                  showValue={true}
                  disabled={!isKeyData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default triggerOperation;
